<template>
  <div class="hello">
    <div v-if="mobile">
      <img
        src="../assets/ais_03.png"
        style="width: 100%; height: auto; vertical-align: top"
      />
      <img
        src="../assets/ais_02.png"
        style="width: 100%; height: auto; vertical-align: top"
      />
      <div align="center">
        <mt-button
          type="primary"
          size="large"
          style="
            width: 80%;
            background-color: #75cd5c;
            font-size: 16px;
            margin-top: 20px;
            font-weight: bold;
          "
          @click.native="handleDownload1"
          >{{ $t('download') }}</mt-button
        >
        <div align="center" style="margin-top: 10px">
          <p style="font-size: 12px; color: #212121">{{ $t('downloadDes') }}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <img
          src="../assets/ais_03.png"
          style="width: 40%; height: auto; vertical-align: top"
        />
      </div>
      <div>
        <img
          src="../assets/ais_02.png"
          style="width: 40%; height: auto; vertical-align: top"
        />
      </div>
      <div align="center">
        <p style="font-size: 24px; color: #212121; margin-top: 10px">
          {{ $t('scan') }}
        </p>
        <qriously :value="url" :size="200" style="margin-top: 10px" />
      </div>
    </div>
    <div id="weixin-tip" v-if="weixinEnv">
      <img
        v-if="lang == 'zh'"
        src="../assets/live_weixin_zh.png"
        style="max-width: 90%"
      />
      <img
        v-else-if="lang == 'en'"
        src="../assets/live_weixin_en.png"
        style="max-width: 90%"
      />
      <img v-else src="../assets/live_weixin_th.png" style="max-width: 90%" />
    </div>
  </div>
</template>

<script>
// import { MessageBox } from 'mint-ui'
export default {
  name: 'share',
  data () {
    return {
      url: '',
      mobile: 1,
      type: 'ios',
      appurl: '',
      downloadurl1: '',
      downloadurl2: 'https://play.google.com/store/apps/details?id=th.co.mimotech.android.aismyliving',
      timeout: 0,
      weixinEnv: 0,
      lang: 'zh'
    }
  },
  created () {
    this.url = window.location.href
    // 测试
    // if (this.lang === 'en') {
    //   this.$i18n.locale = 'en'
    // }
    // console.log(navigator)
    const lang = (
      navigator.language ||
      navigator.userLanguage ||
      'en'
    ).toLowerCase()
    if (lang.includes('zh')) {
      this.lang = 'zh'
      this.$i18n.locale = 'zh'
    } else if (lang.includes('en')) {
      this.lang = 'en'
      this.$i18n.locale = 'en'
    } else {
      this.lang = 'th'
      this.$i18n.locale = 'th'
    }
    // MessageBox.alert(navigator.userAgent, 'navigator.userAgent');
    if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
      this.downloadurl1 = 'https://apps.apple.com/cn/app/id6450340222?mt=8'
      this.type = 'ios'
    } else if (navigator.userAgent.match(/(android|Android)/i)) {
      if (this.lang === 'zh') {
        this.downloadurl1 = 'https://play.google.com/store/apps/details?id=th.co.mimotech.android.aismyliving'
      } else {
        this.downloadurl1 = 'https://play.google.com/store/apps/details?id=th.co.mimotech.android.aismyliving'
      }
      this.type = 'android'
    } else {
      this.type = 'pc'
      this.mobile = 0
    }
    // this.mobile = 0;
    // this.type = 0;
    // this.weixinEnv = 1;
  },

  mounted () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.includes('micromessenger')) {
      this.weixinEnv = 1
    }
    window.addEventListener('hashchange', function (e) {
      //  MessageBox.alert(e.oldURL);
      //  MessageBox.alert(e.newURL);
      window.location.reload()
    })
  },

  methods: {
    handleAccept () {
      // const that = this;
      // var loadDateTime = new Date();
      // // 设置时间阈值，在规定时间里面没有打开对应App的话，直接去App store进行下载。
      // loadTimer = setTimeout(function () {
      //   var timeOutDateTime = new Date();
      //   if (timeOutDateTime - loadDateTime < 2200) {
      //     MessageBox.alert('e.newURL');
      //     window.location.href = that.downloadurl; // APP下载地址
      //   } else {
      //     // window.close();
      //   }
      // }, 2000);

      // // 当本地app被唤起，则页面会隐藏掉，就会触发pagehide与visibilitychange事件
      // // 在部分浏览器中可行，网上提供方案，作hack处理
      // var visibilitychange = function () {
      //   MessageBox.alert('1e.newURL');
      //   var tag = document.hidden || document.webkitHidden;
      //   tag && clearTimeout(loadTimer);
      // };
      // document.addEventListener('visibilitychange', visibilitychange, false);
      // document.addEventListener('webkitvisibilitychange', visibilitychange, false);
      // // pagehide 必须绑定到window
      // window.addEventListener('pagehide', function () {
      //   clearTimeout(loadTimer);
      //   MessageBox.alert('2e.newURL');
      // }, false);

      // window.location.href = this.appurl
    },
    handleDownload1 () {
      console.log(this.downloadurl1)
      window.location.href = this.downloadurl1
    },
    handleDownload2 () {
      window.location.href = this.downloadurl2
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
html {
  color: #42b983;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.timeout_img {
  margin-top: 112px;
}

#image {
  width: 70%;
  height: auto;
}

#weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  z-index: 10;
}

#weixin-tip p {
  text-align: center;
  margin-top: 1%;
  padding: 0 5%;
}
.button {
  margin-top: 80px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/share.vue